// extracted by mini-css-extract-plugin
export default {"container":"prediction-page_container__+LI-e","mobile_view":"prediction-page_mobile_view__AcoqZ"};